import type { ChatMessage } from './chatStore';

export function normalizeMessage(m: ChatMessage): ChatMessage {
  const metadata = m.metadata;
  const createdAt =
    metadata?.createdAt ||
    new Date((m as any).createdAt ?? Date.now()).toISOString();

  return {
    id: m.id ?? crypto.randomUUID(),
    role: m.role,
    parts: sanitizeChatMessageParts(m.parts ?? []),
    metadata: { ...metadata, createdAt }
  };
}

export function sanitizeChatMessageParts(parts: any[]): ChatMessage['parts'] {
  return parts
    .map(part => {
      if (!part || typeof part !== 'object') return null;

      // Drop ephemeral runtime parts
      if (part.type === 'step-start' || part.type === 'dynamic-tool') {
        return null;
      }

      // TEXT / REASONING
      if (part.type === 'text' || part.type === 'reasoning') {
        const textValue =
          typeof part.text === 'string'
            ? part.text
            : typeof part.text?.value === 'string'
              ? part.text.value
              : '';
        return {
          type: part.type,
          text: textValue
        };
      }

      // STRUCTURED DATA (your future edit patches)
      if (part.type.startsWith('data-')) {
        return {
          type: part.type,
          data: structuredClone(part.data)
        };
      }

      // TOOL RESULTS
      if (part.type.startsWith('tool-')) {
        return {
          type: part.type,
          name: part.name ?? part.type.slice(5),
          result:
            part.result !== undefined ? structuredClone(part.result) : undefined
        };
      }

      // Everything else → drop
      return null;
    })
    .filter(Boolean) as ChatMessage['parts'];
}
